import { render } from "./AccountType.vue?vue&type=template&id=646b045d&scoped=true"
import script from "./AccountType.vue?vue&type=script&lang=js"
export * from "./AccountType.vue?vue&type=script&lang=js"

import "./AccountType.vue?vue&type=style&index=0&id=646b045d&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-646b045d"]])

export default __exports__